export default __webpack_public_path__ + "static/work-grainviz-68a703a218ce0424047fe7c6c6e695e5.png";